import { render, staticRenderFns } from "./ModalShippingTracking.vue?vue&type=template&id=94c9438c&"
import script from "./ModalShippingTracking.vue?vue&type=script&lang=js&"
export * from "./ModalShippingTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports